export function ArrowDownIcon({ color }: { color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.60225 10.054C5.82192 10.2737 6.17808 10.2737 6.39775 10.054L9.77275 6.679C9.99242 6.45933 9.99242 6.10317 9.77275 5.8835C9.55308 5.66383 9.19692 5.66383 8.97725 5.8835L6.5625 8.29825V2.34375C6.5625 2.03309 6.31066 1.78125 6 1.78125C5.68934 1.78125 5.4375 2.03309 5.4375 2.34375V8.29825L3.02275 5.8835C2.80308 5.66383 2.44692 5.66383 2.22725 5.8835C2.00758 6.10317 2.00758 6.45933 2.22725 6.679L5.60225 10.054Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
}
